module.exports = __webpack_public_path__ + "static/media/logo128.5c5a3abc.png";